import va from '@vercel/analytics';

export function UserAction(user:string, action:string){
    let properties =  {
        date:(new Date()).toUTCString(),
        user: user
    }
    va.track(action, properties)
}